import React, { useState, useCallback, useEffect } from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './AddProfileApproveModalMessages';

function AddProfileApproveModal({ name, intl, isOpen, onClose, onContinue }) {
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      icon="ti-thumb-up"
      title={intl.formatMessage(messages.title)}
      buttons={[
        {
          label: intl.formatMessage(messages.continue),
          onClick: onContinue,
          primary: true,
        },
      ]}
      small
    >
      <p>{intl.formatMessage(messages.nameFeedback, { name })}</p>
      <p>{intl.formatMessage(messages.emailFeedback)}</p>
    </Modal>
  );
}

export default injectIntl(AddProfileApproveModal);
